import { Component, computed, input } from '@angular/core';
import { NgStyle } from '@angular/common';
import { STATUS_COLOR } from '../../../pages/documents/constants/status-color';
import { Status } from '../../../pages/documents/types/documents.type';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-status-marker',
  imports: [NgStyle, TranslatePipe],
  templateUrl: './status-marker.html',
  styleUrl: './status-marker.scss',
})
export class StatusMarker {
  readonly status = input.required<Status>();

  protected statusKey = computed(() => {
    const status = this.status();
    return `app.documents.status.${Status[status]?.toLowerCase()}`;
  });
  protected statusStyle = computed(() => {
    const status = this.status();
    return STATUS_COLOR[status] ?? {};
  });
}
